// src/data/servicios.js
// Fuente de verdad del contenido de cada servicio. El layout vive en
// src/pages/ServicioDetalle.jsx; acá solo se edita texto.
//
// `icon` referencia una clave del mapa ICONS en ServicioDetalle.jsx.

const servicios = [
  {
    slug: "estrategica",
    title: "Consultoría Estratégica",
    image: "/assets/Servicios/estrategica.jpg",
    hook: "¿Sentís que tu empresa avanza sin rumbo claro? Te ayudamos a definir un norte y un plan para llegar.",
    description: [
      "Definimos junto a vos un rumbo claro para tu empresa. A través de un diagnóstico integral del negocio y su entorno, identificamos oportunidades, fortalezas y desafíos.",
      "Clarificamos la propuesta de valor, fijamos objetivos estratégicos y diseñamos una hoja de ruta por etapas que te permita crecer de forma sostenible.",
    ],
    aspectosLabel: "Aspectos que abordamos:",
    aspectos: [
      "Diagnóstico integral del negocio y su entorno.",
      "Análisis FODA (fortalezas, oportunidades, debilidades y amenazas).",
      "Evaluación de la competencia y posicionamiento.",
      "Análisis de tu modelo de negocio (CANVAS).",
      "Definición de la propuesta de valor, Misión, Visión y Valores.",
      "Formulación de objetivos estratégicos medibles.",
    ],
    beneficios: [
      { title: "DIRECCIÓN CLARA", description: "Dirección clara y alineada en toda la organización.", icon: "Compass" },
      { title: "DECISIONES BASADAS EN DATOS", description: "Toma de decisiones basada en información.", icon: "BarChart2" },
      { title: "ENFOQUE EN OBJETIVOS CLAVE", description: "Enfoque en los objetivos que realmente generan impacto.", icon: "Target" },
      { title: "COHESIÓN ORGANIZACIONAL", description: "Cohesión entre estrategia, operaciones y recursos.", icon: "Users" },
    ],
  },
  {
    slug: "administracion-finanzas",
    title: "Consultoría en Administración y Finanzas",
    image: "/assets/Servicios/administracion-finanzas.jpg",
    hook: "¿Sabés realmente cuánto ganás o perdés por mes? Si no lo medís, no lo podés mejorar.",
    description: [
      "Ordenamos la gestión administrativa y financiera de tu empresa para que puedas tomar decisiones con información real, anticiparte a problemas y mejorar la rentabilidad.",
      "Analizamos costos, procesos, flujo de fondos e indicadores clave para transformar los números en una herramienta de control y crecimiento.",
    ],
    aspectosLabel: "Aspectos que abordamos:",
    aspectos: [
      "Análisis de costos y punto de equilibrio.",
      "Análisis de precios.",
      "Armado del flujo de fondos.",
      "Revisión y mejora de procesos administrativos.",
      "Definición de indicadores clave de gestión (KPI's).",
      "Diseño de tableros de control.",
    ],
    beneficios: [
      { title: "CLARIDAD SOBRE RENTABILIDAD", description: "Mayor claridad sobre la rentabilidad real del negocio.", icon: "BarChart2" },
      { title: "CONTROL FINANCIERO", description: "Mejor control del dinero, los costos y los precios.", icon: "DollarSign" },
      { title: "MENOS ERRORES", description: "Menos errores, reprocesos y dependencia de información informal.", icon: "ShieldCheck" },
      { title: "DECISIONES ÁGILES", description: "Decisiones más rápidas, ordenadas y basadas en datos.", icon: "TrendingUp" },
    ],
  },
  {
    slug: "produccion-logistica",
    title: "Consultoría en Producción y Logística",
    image: "/assets/Servicios/produccion-logistica.jpg",
    hook: "Si tus costos suben y los tiempos no cierran, hay ineficiencias que te están frenando.",
    description: [
      "Optimizamos la operación industrial y logística de tu PyME.",
      "Detectamos cuellos de botella, reducimos tiempos improductivos y diseñamos flujos de trabajo para mejorar la productividad y eficiencia de tu Planta.",
    ],
    aspectosLabel: "Aspectos que abordamos:",
    aspectos: [
      "Revisión y mejora del flujo productivo.",
      "Definición o ajuste del layout industrial.",
      "Detección de cuellos de botella, desperdicios y tiempos improductivos.",
      "Análisis de productividad y eficiencia por proceso.",
      "Planificación de la producción.",
      "Optimización de la cadena logística.",
      "Gestión y control de stock.",
      "Definición de indicadores clave de gestión (KPI's).",
    ],
    beneficios: [
      { title: "MEJORA EN PRODUCTIVIDAD", description: "Mejora en la productividad y tiempos de entrega.", icon: "TrendingUp" },
      { title: "REDUCCIÓN DE COSTOS", description: "Reducción de costos operativos y logísticos.", icon: "PieChart" },
      { title: "PROCESOS ESCALABLES", description: "Procesos más ordenados, controlados y escalables.", icon: "Layers" },
      { title: "CONTROL DE PRODUCCIÓN", description: "Mejor control sobre la producción, el stock y la capacidad de respuesta.", icon: "Package" },
    ],
  },
  {
    slug: "recursos-humanos",
    title: "Consultoría en Recursos Humanos",
    image: "/assets/Servicios/recursos-humanos.jpg",
    hook: "Cuando RR.HH. no está ordenado, todo se frena: legajos, roles, licencias y políticas se vuelven problemas en lugar de soluciones.",
    description: [
      "Ordenamos y profesionalizamos la gestión de Recursos Humanos para que la empresa tenga roles claros, procesos definidos y herramientas simples para gestionar mejor a sus equipos. Alineamos estructura, desempeño y cultura con los objetivos del negocio.",
    ],
    aspectosLabel: "Aspectos que abordamos:",
    aspectos: [
      "Diseño de la estructura organizacional (Organigrama).",
      "Creación de manuales de puestos de trabajo.",
      "Armado de legajos digitales y físicos.",
      "Redacción de reglamento, políticas y manual de convivencia.",
      "Herramientas de gestión de licencias, vacaciones, capacitaciones y evaluaciones de desempeño.",
      "Definición de indicadores clave de gestión (KPI's).",
    ],
    beneficios: [
      { title: "ROLES CLAROS", description: "Roles y responsabilidades claras.", icon: "Users" },
      { title: "GESTIÓN PROFESIONAL", description: "Gestión de RR.HH. más ordenada, ágil y profesional.", icon: "FileText" },
      { title: "DECISIONES BASADAS EN DATOS", description: "Decisiones de RR.HH. basadas en datos y no en percepciones.", icon: "CheckSquare" },
      { title: "EQUIPOS ALINEADOS", description: "Equipos más alineados, productivos y comprometidos.", icon: "Award" },
    ],
  },
  {
    slug: "comercial",
    title: "Consultoría Comercial",
    image: "/assets/Servicios/comercial.jpg",
    hook: "Vender más no siempre significa vender mejor. Sin procesos, seguimiento e indicadores, la gestión comercial pierde oportunidades todos los días.",
    description: [
      "Ordenamos y profesionalizamos la gestión comercial de tu empresa para mejorar la planificación, el seguimiento de oportunidades y la toma de decisiones. Analizamos el proceso de venta, los roles comerciales, la información disponible y los indicadores clave para diseñar una gestión más clara, medible y orientada a resultados.",
    ],
    aspectosLabel: "Aspectos que abordamos:",
    aspectos: [
      "Diagnóstico del proceso comercial actual.",
      "Revisión de roles, responsabilidades y circuitos de venta.",
      "Documentación de procesos comerciales.",
      "Diseño de etapas del proceso de venta y seguimiento de oportunidades.",
      "Definición de indicadores comerciales clave.",
      "Armado de tableros de control y reportes de gestión.",
      "Análisis de clientes, canales y comportamiento de ventas.",
    ],
    beneficios: [
      { title: "SEGUIMIENTO EFECTIVO", description: "Mejor seguimiento de clientes, oportunidades y resultados.", icon: "Target" },
      { title: "DECISIONES INFORMADAS", description: "Decisiones comerciales basadas en información real.", icon: "BarChart2" },
      { title: "EQUIPOS ENFOCADOS", description: "Equipos comerciales más alineados y enfocados en objetivos.", icon: "Users" },
      { title: "MAYOR CONVERSIÓN", description: "Mejora en la conversión, la planificación y la rentabilidad comercial.", icon: "TrendingUp" },
    ],
  },
  {
    slug: "contable-impositivo",
    title: "Contable-Impositivo",
    image: "/assets/Servicios/contable-impositivo.jpg",
    hook: "Nos ocupamos de que tu empresa cumpla en tiempo y forma, evitando errores, multas y preocupaciones innecesarias.",
    description: [
      "Brindamos un servicio contable e impositivo integral para que tu empresa pueda cumplir con sus obligaciones fiscales de manera ordenada, segura y eficiente. Nos ocupamos de la liquidación de impuestos, registraciones contables, balances y asesoramiento permanente, para que puedas enfocarte en la gestión y crecimiento de tu negocio.",
    ],
    aspectosLabel: "Aspectos que abordamos:",
    aspectos: [
      "Liquidación de impuestos municipales, provinciales y nacionales.",
      "Registraciones contables de la empresa.",
      "Asesoramiento contable e impositivo.",
      "Liquidación de ganancias para personas físicas y jurídicas.",
      "Armado y certificación de balances.",
      "Seguimiento de vencimientos y obligaciones fiscales.",
      "Presentación de declaraciones juradas y regímenes informativos.",
    ],
    beneficios: [
      { title: "CUMPLIMIENTO FISCAL", description: "Cumplimiento fiscal en tiempo y forma.", icon: "CheckSquare" },
      { title: "MENOR RIESGO", description: "Menor riesgo de multas, errores o incumplimientos.", icon: "ShieldCheck" },
      { title: "INFORMACIÓN CONFIABLE", description: "Información contable más ordenada y confiable.", icon: "FileText" },
      { title: "TRANQUILIDAD TOTAL", description: "Mayor tranquilidad frente a inspecciones, vencimientos y presentaciones.", icon: "Shield" },
    ],
  },
  {
    slug: "liquidacion-sueldos",
    title: "Liquidación de Sueldos",
    image: "/assets/Servicios/liquidacion-sueldos.jpg",
    hook: "Liquidar mal los sueldos puede costarte caro: en multas, en tiempo y en tranquilidad.",
    description: [
      "Nos ocupamos de la liquidación de sueldos y del cumplimiento de las normativas laborales para que puedas enfocarte en el core de tu negocio. Aseguramos precisión, confidencialidad y actualización permanente frente a los cambios legales.",
    ],
    aspectosLabel: "Aspectos que incluye:",
    aspectos: [
      "Liquidación de sueldos y jornales.",
      "Gestión de cargas sociales (ARCA).",
      "Boletas sindicales.",
      "Altas y bajas en ARCA.",
      "Certificación de servicios.",
      "Asesoramiento en relaciones laborales.",
    ],
    beneficios: [
      { title: "CUMPLIMIENTO LEGAL", description: "Cumplimiento legal sin errores ni sanciones.", icon: "Shield" },
      { title: "CONFIDENCIALIDAD", description: "Confidencialidad y precisión en la información.", icon: "FileText" },
      { title: "AHORRO DE TIEMPO", description: "Ahorro de tiempo para enfocarte en el negocio.", icon: "CheckSquare" },
      { title: "TRANQUILIDAD TOTAL", description: "Tranquilidad frente a inspecciones o auditorías.", icon: "Users" },
    ],
  },
  {
    slug: "seleccion-personal",
    title: "Selección de Personal",
    image: "/assets/Servicios/seleccion-personal.jpg",
    hook: "Encontrar a la persona adecuada no es cuestión de suerte, sino de método y conocimiento humano.",
    description: [
      "En Core Solutions entendemos que el éxito de una organización depende directamente del talento que la integra. Por eso, desarrollamos procesos de selección personalizados, enfocados en detectar no solo habilidades técnicas, sino también competencias blandas, valores y cultura organizacional.",
    ],
    aspectosLabel: "Aspectos que incluye:",
    aspectos: [
      "Definición de perfiles de puestos vacantes.",
      "Diseño de procesos de selección a medida.",
      "Publicación y filtrado de candidatos.",
      "Entrevistas por competencias.",
      "Evaluaciones psicotécnicas, evaluaciones de potencial y assessment center.",
      "Verificación de referencias laborales.",
      "Presentación de informes y recomendaciones finales.",
    ],
    beneficios: [
      { title: "CONTRATACIONES PRECISAS", description: "Contrataciones más precisas y alineadas con la cultura.", icon: "Search" },
      { title: "RETENCIÓN DE TALENTO", description: "Atracción y retención de talento calificado.", icon: "Users" },
      { title: "AHORRO DE TIEMPO", description: "Ahorro de tiempo para el equipo interno.", icon: "ClipboardCheck" },
      { title: "PROCESOS TRANSPARENTES", description: "Procesos más objetivos y transparentes.", icon: "FileText" },
    ],
  },
  {
    slug: "gestion-talento",
    title: "Gestión del Talento",
    image: "/assets/Servicios/gestion-talento.jpg",
    hook: "Las personas hacen la diferencia, pero solo si están en el lugar correcto, con objetivos claros y la motivación adecuada.",
    description: [
      "Acompañamos a las empresas a desarrollar, evaluar y fortalecer el talento para mejorar el desempeño, el clima laboral y el compromiso de los equipos.",
      "Identificamos oportunidades de mejora en las personas, los liderazgos y la cultura organizacional, diseñando acciones concretas para potenciar el crecimiento del equipo y reducir la rotación.",
    ],
    aspectosLabel: "Aspectos que abordamos:",
    aspectos: [
      "Evaluaciones de desempeño.",
      "Diagnóstico de clima y cultura organizacional.",
      "Diagnóstico de liderazgo y acompañamiento a mandos medios.",
      "Diseño de programas de capacitación personalizados.",
    ],
    beneficios: [
      { title: "MEJOR CLIMA LABORAL", description: "Mejora del clima laboral y la motivación.", icon: "Activity" },
      { title: "EQUIPOS SÓLIDOS", description: "Equipos más sólidos, motivados y autogestionados.", icon: "Users" },
      { title: "LIDERAZGO FORTALECIDO", description: "Liderazgos más preparados para acompañar el crecimiento.", icon: "Award" },
      { title: "MENOR ROTACIÓN", description: "Menor rotación y mayor cohesión del equipo.", icon: "BarChart2" },
    ],
  },
  {
    slug: "herramientas-automatizadas",
    title: "Herramientas Automatizadas",
    image: "/assets/Servicios/herramientas-automatizadas.jpg",
    hook: "Si tu equipo pierde horas cargando datos, copiando información o corrigiendo errores, hay procesos que pueden automatizarse.",
    description: [
      "Diseñamos herramientas automatizadas en Excel o Google Sheets, personalizadas según la realidad de cada empresa, para optimizar la gestión diaria y mejorar el control de la información.",
    ],
    aspectosLabel: "Aspectos que abordamos:",
    aspectos: [
      "Relevamiento del proceso actual y necesidades de información.",
      "Diseño de herramientas personalizadas según cada área o gestión.",
      "Automatización de cálculos, reportes, alertas y controles.",
      "Armado de tableros, indicadores y reportes de seguimiento.",
      "Integración de bases de datos, formularios y registros internos.",
      "Capacitación para el uso de la herramienta implementada.",
    ],
    ejemplosLabel: "Ejemplos de herramientas:",
    ejemplos: [
      "Flujo de caja y estado de resultados.",
      "Cálculo de costos mensuales y análisis de rentabilidad.",
      "Gestión de inventarios, pedidos y cotizaciones.",
      "Control de vacaciones, licencias y novedades del personal.",
      "Evaluaciones de desempeño y tableros de RR.HH.",
      "Reportes comerciales, administrativos, financieros u operativos.",
    ],
    beneficios: [
      { title: "AHORRO DE TIEMPO", description: "Ahorro de tiempo en tareas operativas y administrativas.", icon: "Activity" },
      { title: "MENOS ERRORES", description: "Reducción de errores por carga manual o información duplicada.", icon: "ShieldCheck" },
      { title: "MAYOR CONTROL", description: "Mayor orden, trazabilidad y control de la información.", icon: "PieChart" },
      { title: "DECISIONES MÁS RÁPIDAS", description: "Reportes actualizados para tomar decisiones más rápido.", icon: "BarChart2" },
    ],
  },
];

export default servicios;

export function getServicioBySlug(slug) {
  return servicios.find((s) => s.slug === slug);
}
